import React from 'react'
import { InfoTooltip } from '@sales-center/components'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'

export default function SearchToolTip() {
  const { t } = useTranslation()
  const theme = useTheme()
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.3,
      }}
    >
      <Typography variant="body2">Search Tips</Typography>
      <InfoTooltip
        arrow
        tooltipWidth="563px"
        tooltipShadow={2}
        infoText={
          <Stack
            sx={{
              padding: `${theme.spacing(1.4)} ${theme.spacing(
                2.4,
              )} ${theme.spacing(2)} ${theme.spacing(2.4)}`,
            }}
          >
            <Typography
              marginBottom={0.5}
              color={theme.palette.text.primary}
              variant="h6"
              fontWeight={700}
            >
              Search Tips
            </Typography>
            <Typography color={theme.palette.text.primary} variant="body2">
              <Box>
                <strong>Name/Company Name:</strong> Search by first name, last
                name and/or company name
              </Box>
              <Box>
                <strong>Phone:</strong> Use xxx-xxx-xxxx, (xxx)-xxx-xxxx, xxx
                xxx xxxx, or (xxx) xxx-xxxx formats
              </Box>
              <Box>
                <strong>Address:</strong> Search by street number, street name,
                city, {t('state').toLowerCase()}, and/or{' '}
                {t('postalCode').toLowerCase()}
              </Box>
              <Box>
                <strong>Email:</strong> Use address@domain.com format
              </Box>
              <Box>
                <strong>Location Number:</strong> Search by bill-to or service
                location number
              </Box>
              <Box>
                <strong>Operators:</strong> Use &quot;OR&quot; to increase
                search results (John OR Smith), use quotes to search an exact
                match (“John Smith”)
              </Box>
            </Typography>
          </Stack>
        }
        tooltipPlacement="bottom"
        fontSize={16}
      />
    </Box>
  )
}
